import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { GlobalBlockContext } from "../content/global"
import { useContext } from "react"

export const meta: BlockMeta = {
  title: "Feature Callout",
  tags: ["#page"],
}

export default defineBlock("section/feature-callout", (props) => {
  const { isGlobalBlock } = useContext(GlobalBlockContext)

  return (
    <Appear
      className={cn(
        "feature-callout w-full my-9 max-w-blogPostVideoW block-padding mx-auto [&_.inline-media-item]:!aspect-[488/500] [&_.feature-callout-inner_.inline-media-item]:!aspect-auto",
        (!env.admin || isGlobalBlock) &&
          "grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10 [&_.inline-media-item]:order-first [&_.feature-callout-inner]:order-last [&_.inline-media-item]:md:order-last [&_.feature-callout-inner]:md:order-first [&_.feature-callout-inner_.inline-media-item]:!order-none",
        props.alternate &&
          (!env.admin || isGlobalBlock) &&
          "[&_.inline-media-item]:md:order-first [&_.feature-callout-inner]:md:order-last",
      )}
    >
      <InnerBlocks
        allowedBlocks={["section/feature-callout-inner", "content/inline-media"]}
        adminClassName={cn(
          "grid grid-cols-1 md:grid-cols-2 gap-10 [&>div]:h-full",
          props.alternate &&
            "[&_.wp-block-acf-content-inline-media]:order-first [&_.wp-block-acf-section-feature-callout-inner]:order-last",
        )}
        template={[
          ["section/feature-callout-inner", {}],
          ["content/inline-media", {}],
        ]}
      />
    </Appear>
  )
})
